import React, { useState, useEffect } from 'react';
import { RootState } from 'store/ducks';
import { useSelector } from 'react-redux';

import { Visibility } from 'components/Visibility';
import Loading from '../Loading';
import Text from 'components/Text';

import { OperationTypes } from 'models/Order';
import CompanyService from 'services/company.service';
import DownloadService from 'services/download.service';
import { AllDocumentsProps, MenuCompaniesProps } from './interface';

import { Container, ListSubsidiaries, ListDocumentsSudsidiaries } from './styles';

export const MenuCompanies: React.FC<MenuCompaniesProps> = (props) => {

  const { allCompanies, companySelected } = props;
  const [documents, setDocuments] = useState<AllDocumentsProps[]>([]);
  const [subsidiarySelected, setSubsidiarySelected] = useState<AllDocumentsProps>();
  const [loading, setLoading] = useState(true);
  const user = useSelector((state: RootState) => state.user);
  const customer = useSelector((state: RootState) => state.customer);

  const _companyServices = new CompanyService();
  const _downloadServices = new DownloadService();

  useEffect(() => {
    getDocuments();
  }, [allCompanies, companySelected]);

  const getDocuments = async () => {
    setLoading(true);

    if (allCompanies && companySelected) {
      const response = await _companyServices.getRegulatoryDocuments({
        and: [
          { "enterpriseName": { eq: companySelected } }
        ]
      });
      setTimeout(() => {
        setDocuments(response.data);
        setSubsidiarySelected(response.data[0]);
        setLoading(false);
      }, 1000);
    }
  };

  const getDocumentsCompany = (subsidiary: AllDocumentsProps) => {
    setSubsidiarySelected(subsidiary);
  };

  const getTitleDocumentsCompany = (topicName: string, companyRegister: string) => {
    if (!companyRegister) {
      return `${topicName}`;
    }
    
    return `${topicName} - ${companyRegister}`;
  }

  const downloadRegulatoryDocument = async (
    regulatoryDocumentId: string,
    enterpriseId: string,
    topicsSubsidiaryId: string
  ) => {
    const customerId = user?.userType === 'employee' ? customer?.id : user?.selectedCustomerId;
    await _downloadServices.DownloadRegulatoryDocument(
      customerId,
      OperationTypes.REGULATORY_DOCUMENT,
      regulatoryDocumentId,
      enterpriseId,
      topicsSubsidiaryId
    );
  };

  return (
    <Container loading={loading.toString()} documents={documents.length}>
      <Visibility visible={loading}>
        <Loading onlySpinner />
      </Visibility>

      <Visibility visible={!loading && documents.length === 0}>
        <Text>
          Nenhum documento encontrado para a empresa {companySelected}
        </Text>
      </Visibility>

      <Visibility visible={!loading && documents.length > 0}>
        <ListSubsidiaries>
          {
            documents.map((subsidiary) => (
              <li key={subsidiary.subsidiaryLocalization}>
                <a
                  title="Link Filiais"
                  className={
                    subsidiarySelected?.subsidiaryLocalization === subsidiary.subsidiaryLocalization ?
                      'active' : ''
                  }
                  onClick={() => getDocumentsCompany(subsidiary)}>
                  {subsidiary.subsidiaryLocalization}
                </a>
              </li>
            ))
          }
        </ListSubsidiaries>
        <ListDocumentsSudsidiaries companies={subsidiarySelected?.topicsSubsidiary.length || 0}>
          {
            !loading && subsidiarySelected?.topicsSubsidiary.map((topicsSubsidiary) => (
              <div key={topicsSubsidiary.topicName}>
                <h2 className="color-primary">
                  {getTitleDocumentsCompany(topicsSubsidiary.topicName, topicsSubsidiary.companyRegister)}
                </h2>
                <ul>
                  {topicsSubsidiary.listRegulatoryDocumentsDetail.map((document) => (
                    <li key={document.documentName}>
                      <a
                        title="Clique para fazer o download"
                        href={document.url}
                        target="_blank"
                        onClick={() => downloadRegulatoryDocument(
                          document.id,
                          subsidiarySelected.id,
                          topicsSubsidiary.id
                        )}>
                        {document.documentName}
                      </a>
                    </li>
                  ))
                  }
                </ul>
              </div>
            ))
          }
        </ListDocumentsSudsidiaries>
      </Visibility>
    </Container>
  );
};